import * as React from 'react';
import './KPSelectableTile.css';
import { ISelectableTile } from '../../../../interfaces/KPSelectableTile/KPSelectableTileInterfaces';

class KPSelectableTile extends React.Component<ISelectableTile, any>{
    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect() {
        let id = this.props.id;
        let selected = !this.props.selected;
        if (this.props.handleSelect) {
            this.props.handleSelect(id, selected);
        }
    }

    public render() {
        return (
            <>
                <div onClick={this.handleSelect} className={"cursor-pointer " + (this.props.colClassName !== undefined ? this.props.colClassName : "col")}>
                    <div className={"ssp-selectable-tile-structure" + (this.props.selected ? " selected" : "") }>
                        <div className="row mt-12px pr-3">
                            <div className="col-2 col-md-3 nopa">
                                <div className={"ssp-selectable-tile-select-item-box" + this.props.className + (this.props.selected ? " selected" : "")}  ></div>
                            </div>
                            <div className="col-10 col-md-9 pl-2 pr-2">
                                <span className="ssp-selectable-tile-heading"> {this.props.title} </span>
                            </div>
                        </div>
                        <div className="row mt-12px">
                            <div className="col-4 col-md-12 justify-content-center">
                                <img src={this.props.tileImage} alt="image description" style={{ width: "100%", maxWidth:"100px" } }></img>
                            </div>
                            <div className="col-8 col-md-12 ssp-selectable-tile-body-text mt-12px mb-12px">
                                {this.props.body}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default KPSelectableTile